export var MAIN_DC_URL = 'https://manage.wix.com';
export var EVENTS_WEB_API_BASE = '/_api/wix-one-events-server';
export var MEMBERS_PERMISSIONS_BASE = '/_api/member-permissions-server';
export var SERVER_BASE_URL = 'https://events.wixapps.net/events-server';
export var IFRAME_BASE_URL = 'https://editor.wixapps.net/events-server';
export var LIVE_VIDEO_API_URL = '/_api/livevideo-server';
export var PAYMENT_SERVICES_API_URL = '/_api/payment-services-web';
export var SCHEDULE_API_URL = '/_api/wix-events-schedule';
export var EVENTS_WEB_API_URL = '/_api/wix-events-web';
export var SEATINGS_API_URL = '/_api/seating-plans';
export var GROUPS_API_URL = '/_api/social-groups';
//# sourceMappingURL=endpoints.js.map